import { UPDATE_IS_EXPANDED } from '../actions';

export const widgetExpanded = (state = false, action) => {
  switch (action.type) {
    case UPDATE_IS_EXPANDED: {
      return action.isExpanded;
    }
    default:
      return state;
  }
};
